enum CollectionsDirectoryQA {
  CollectionsDirectory = 'CollectionsDirectory',
  CollectionsDirectorySectionTab = 'CollectionsDirectorySectionTab',
  CollectionsDirectoryGroupPill = 'CollectionsDirectoryGroupPill',
  CollectionsDirectoryLinkGrid = 'CollectionsDirectoryLinkGrid',
  CollectionsDirectoryLink = 'CollectionsDirectoryLink',
  CollectionsDirectoryToggleButton = 'CollectionsDirectoryToggleButton',
}

export default CollectionsDirectoryQA
